
<div class="layout"
  (click)="$event.stopPropagation()"
  (keydown.escape)="$event.stopPropagation()"
  >

  <div class="user-info">
    <div class="user-info-name">{{ name }} {{ surname }}</div>
    <div class="user-info-email">{{ email }}</div>
  </div>



  <div class = "afterName"></div>
  <button mat-menu-item (click)="resetPassword()">
    <mat-icon>vpn_key</mat-icon>
    <span>{{ 'Reset Password' | translate }}</span>
  </button>




  <button mat-menu-item (click)="logout()">
    <mat-icon>exit_to_app</mat-icon>
    <span>{{ 'Sign out' | translate }}</span>
  </button>

  <div class="afterSignOut"></div>
  <mat-divider></mat-divider>

  <!-- Language Selector -->
  <div class="language-selector-wrapper" style="margin: 16px 0;">
    <nz-form-item>
      <nz-form-label [nzSpan]="24">{{ 'Language' | translate }}</nz-form-label>
      <nz-form-control [nzSpan]="24">
        <nz-select
          style="width: 100%;"
          [(ngModel)]="defaultLanguage"
          (ngModelChange)="changeLanguage($event)"
          nzPlaceHolder="{{ 'Select Language' | translate }}"
          >

          @for (lang of languageOptions; track lang) {
            <nz-option
              [nzValue]="lang.value"
              [nzLabel]="lang.label | translate"
              >
            </nz-option>
          }
        </nz-select>
      </nz-form-control>
    </nz-form-item>
  </div>

</div>
